var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 268,
    viewBox: "0 0 520 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.081 3.58057H1V0.580566H518H519.5V2.08057V267H516.5V24.9663L501.081 3.58057Z",
    fill: "#4083E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.081 3.58057L501.388 3.35968L501.275 3.20287H501.081V3.58057ZM1 3.58057H0.622302V3.95826H1V3.58057ZM1 0.580566V0.202869H0.622302V0.580566H1ZM519.5 0.580566H519.878V0.202869H519.5V0.580566ZM519.5 267V267.378H519.878V267H519.5ZM516.5 267H516.122V267.378H516.5V267ZM516.5 24.9663H516.878V24.8443L516.806 24.7454L516.5 24.9663ZM501.081 3.20287H1V3.95826H501.081V3.20287ZM1.3777 3.58057V0.580566H0.622302V3.58057H1.3777ZM1 0.958264H518V0.202869H1V0.958264ZM518 0.958264H519.5V0.202869H518V0.958264ZM519.122 0.580566V2.08057H519.878V0.580566H519.122ZM519.122 2.08057V267H519.878V2.08057H519.122ZM519.5 266.622H516.5V267.378H519.5V266.622ZM516.878 267V24.9663H516.122V267H516.878ZM516.806 24.7454L501.388 3.35968L500.775 3.80145L516.194 25.1872L516.806 24.7454Z",
    fill: "#4083E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineR);
export default __webpack_public_path__ + "static/media/line_r.8353abe928872df1ea2eb872a365a645.svg";
export { ForwardRef as ReactComponent };